const CorazonIcon = ({ color, clase }) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clase}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4231 17.7691C12.1098 17.7662 11.7342 17.6131 11.2963 17.3099C7.21908 14.1953 2.69232 11.3168 2.69232 5.92008C2.69232 2.59417 5.04717 0 8.04424 0C9.7374 0 11.3624 0.871965 12.4231 2.23867C13.4837 0.871965 15.1088 0 16.8019 0C19.799 0 22.1539 2.59417 22.1539 5.92008C22.1539 11.3741 17.4228 14.3089 13.5382 17.3099C13.1081 17.62 12.7364 17.7741 12.4231 17.7691Z"
        fill={color}
      />
      <path
        d="M1 7.89795H7.28571L10.4286 5.92188V11.845L17.969 5.92188L17.9714 9.87145H23"
        stroke="#006299"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CorazonIcon;
